// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"c580a0b6fc4c83b7","5285":"db0349bddfce4d1c"}[chunkId] + ".css";
};